import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetPaginatedOrganizationStudentsWithoutTceUseCaseInterface } from 'domain/usecases';

export class RemoteGetPaginatedOrganizationStudentsWithoutTce
  implements GetPaginatedOrganizationStudentsWithoutTceUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetPaginatedOrganizationStudentsWithoutTceUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetPaginatedOrganizationStudentsWithoutTceUseCaseInterface.Params,
  ): Promise<GetPaginatedOrganizationStudentsWithoutTceUseCaseInterface.Result> {
    const {
      organizationHashId,
      page,
      length,
      courseHashIds,
      groupHashIds,
      search,
      orderColumn,
      orderDirection,
    } = params;

    const requestUrl = `${this.url}/${organizationHashId}/students-without-tce/${page}/${length}`;
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(requestUrl, {
        'courseHashIds[]': courseHashIds,
        'groupHashIds[]': groupHashIds,
        search,
        orderColumn,
        orderDirection,
      }),
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
